import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthorityStatus } from 'src/app/models/CalendarModels';

@Component({
  selector: 'app-authorities-status-dialog',
  templateUrl: './authorities-status-dialog.component.html',
  styleUrls: ['./authorities-status-dialog.component.scss']
})
export class AuthoritiesStatusDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AuthoritiesStatusDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }
  close() {
    this.dialogRef.close();
  }

}
